var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.0002,
    r: 16.5,
    stroke: "#3B5998"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4655 12.4954C18.4497 13.0799 18.4415 14.4341 18.4415 14.4341C18.4415 14.4341 19.9525 14.4341 20.6119 14.4341H21.134C21.0121 15.3681 20.8944 16.2667 20.7766 17.1691H18.4614V23.3854C17.7508 23.5622 17.0132 23.6525 16.2519 23.6525C16.0401 23.6525 15.8321 23.6446 15.6241 23.6288V17.1612H13.3047V14.4341H15.6399V14.2298C15.6399 13.6803 15.6282 13.1348 15.6399 12.5856C15.6515 12.2366 15.6669 11.8834 15.7264 11.5377C15.8712 10.706 16.256 10.0033 16.9504 9.50117C17.559 9.06521 18.2534 8.88879 18.991 8.873C19.474 8.86134 19.9525 8.88466 20.4351 8.90459C20.698 8.92039 20.9613 8.95537 21.2084 8.97907V11.4199H21.0162C20.5453 11.4199 20.0781 11.4083 19.6072 11.4241C18.9636 11.4474 18.4888 11.6908 18.4655 12.4954Z",
    fill: "#3B5998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.db03e521b582941201d2e0f81cfe9397.svg";
export { ForwardRef as ReactComponent };